<template>
    <div class="editpage">
        <!-- 面包屑 -->
        <div class="bread">
            <h2>
                <router-link to="/dashboard/classify" class="root" style="width: 100px;"><span
                        @click="goIndex">单证分类管理</span></router-link>
                &nbsp;<i class="el-icon-arrow-right"></i>&nbsp;<span class="curPage">{{this.$route.query.id ? '编辑单证类型' :
                    '创建单证类型'}}</span>
            </h2>
            <div class="back" @click="goBack">
                <h3>&lt; 返回上一级</h3>
            </div>
        </div>
        <div class="content">
            <editContent></editContent>
        </div>
    </div>
</template>
<script>
    import bus from '@/assets/js/bus'
    import busType from '@/assets/js/busType'
    import editContent from './editContent'

    import edit from '@/assets/js/mixin/classifyEdit'

    export default {
        name: 'editpage',
        mixins: [edit],
        props: {},
        data() {
            return {}
        },
        computed: {},
        components: {
            editContent
        },
        watch: {},
        mounted() {
            // 入口 => edit.js
            let id = this.$route.query.id
            this.getOcrById(id)

            bus.$on(busType.RESETINDENTITY, e => {
                if (e && ['DocFields', 'AddFiedBtn'].indexOf(e) != -1) {
                    //不切换图
                } else {
                    this.$store.dispatch('setCurrentImage', 0)
                }

                this.handleImage(id)
            })
        },
        destroyed() {
            bus.$off(busType.RESETINDENTITY)
            this.$store.dispatch('setCurrentImage', 0)
        },
        methods: {
            handleImage(id, e) {
                this.getOcrById(id)
            },
            goBack() {
                this.$store.dispatch('setEditTemplate', null)

                this.$router.push('/dashboard/classify/index')
            },
            goIndex() {
                this.$store.dispatch('setEditTemplate', null)
            }
        }
    }
</script>
<style>
    @import './editpage.css';
</style>